/**
 * Base store factory for Pinia.
 * Provides common CRUD patterns (get, fetch) for resource-based stores.
 *
 * Usage:
 *   import { createBaseStore } from '~/stores/base'
 *   const baseActions = createBaseStore('attributes')
 */

export function createBaseStore(prefix) {
  return {
    state: {
      results: null,
    },
    actions: {
      async get(params = {}) {
        const { $api } = useNuxtApp();
        const response = await $api.get(prefix, params);
        this.results = response?.data;

        return response;
      },
      async fetch(params = {}) {
        if (params) {
          params.resources.forEach((type) => {
            this.results = { ...this.results, [type]: [] };
          });
        }
        const { $api } = useNuxtApp();
        const response = await $api.get(prefix, params);
        this.results = { ...this.results, ...response?.data };

        return response;
      },
    },
  };
}
